// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3pRkD","col":"styles_col__3A0Rd"};